import { useQuery } from "@apollo/client"

import { graphql } from "../gql/__generated__"
import { CancelType } from "../gql/__generated__/graphql"

const query = graphql(/* GraphQL */ `
	query getCancelTypeInfos {
		cancelTypeInfo {
			cancelType
			text
		}
	}
`)

export const useCancelTypeInfos = () => {
	const { data } = useQuery(query, {
		fetchPolicy: "cache-first",
	})

	const cancelTypeInfos = data?.cancelTypeInfo ?? []

	const getCancelTypeLabel = (cancelType: string) =>
		cancelTypeInfos.find((info) => info.cancelType === cancelType)?.text || ""

	const isCancelType = (value: string): value is CancelType => {
		return cancelTypeInfos.some((info) => info.cancelType === value)
	}

	return {
		cancelTypeInfos,
		getCancelTypeLabel,
		isCancelType,
	}
}
